import React from 'react';
import PropTypes from 'prop-types';

import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Link from '@mui/material/Link';
import {Typography} from '@mui/material';
import { grey } from '@mui/material/colors';
import {styled} from '@mui/system';

import GoogleLink from './GoogleLink';
import DoiLink from './DoiLink';
import AuthorList from './AuthorList';
import AffiliationList from './AffiliationList';


const StyledMetadata = styled('div')({
    margin: 0,
    padding: 0
});

const StyledDetailsIcon = styled('div')({
    float: 'right'
});

const StyledDetailsContent = styled(Collapse)({
    marginBottom: 30,
    padding: 0
});

const StyledNoDataFound = styled('p')({
    fontStyle: 'italic'
});

const StyledLinkDefault = styled(Link)({
    textDecoration: 'none',
    '&:hover':{
        textDecoration: 'underline'
    }
});

const StyledLinkDisabled = styled(StyledLinkDefault)({
    color: grey[500]
});

const StyledDetailsTitle = styled(Typography)(({ theme }) =>({
    fontSize: theme.custom.font.small,
    fontWeight: theme.custom.font.bold,
    margin: '15px 0 3px 0',
    padding: 0
}));


class PublicationListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open_details: []
        };
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    handleDetailsClick = (event) => {
        let id = event.currentTarget.dataset.id;
        let open_details = this.state.open_details;
        let index = this.state.open_details.indexOf(id);
        if (index > -1) {
            open_details.splice(index, 1);
        }else{
            open_details.push(id);
        }
        this.setState({open_details: open_details});
    };

    detailsOpen = (id) => {
        return !!(this.state.open_details && this.state.open_details.indexOf(id) >= 0);
    };

    render() {
        let publication = this.props.publication;
        let StyledLink = this.props.disabled ? StyledLinkDisabled : StyledLinkDefault;
        if(publication.html_escaped_title){
            return (
                <StyledMetadata>
                    <StyledDetailsIcon onClick={this.handleDetailsClick} data-id={publication.id}>
                        {this.detailsOpen(publication.id) ? <ExpandLess /> : <ExpandMore />}
                    </StyledDetailsIcon>
                    <StyledLink
                        target="_blank"
                        rel="noreferrer"
                        onClick={this.stopPropagation}
                        href={`https://app.dimensions.ai/details/publication/${publication.id}`}>
                        {publication.html_escaped_title}</StyledLink>
                    <StyledMetadata><AuthorList authors={publication.authors} /></StyledMetadata>
                    <StyledMetadata><AffiliationList affiliations={publication.affiliations} /></StyledMetadata>
                    <StyledMetadata>
                        {!this.props.hideYears && publication.pub_year}
                        {!this.props.hideYears && publication.pub_year && (publication.journal_title || publication.publication_type) && ', '}
                        {publication.journal_title}{publication.journal_title && publication.publication_type && ' - '}
                        {publication.publication_type}
                    </StyledMetadata>
                    <GoogleLink query={publication.title} disabled={this.props.disabled} />{publication.doi && <span> | <DoiLink doi={publication.doi} disabled={this.props.disabled} /></span>}

                    <StyledDetailsContent in={this.detailsOpen(publication.id)} timeout="auto" unmountOnExit>

                        <StyledDetailsTitle>DOI</StyledDetailsTitle>
                        <StyledMetadata>{publication.doi || '-'}</StyledMetadata>

                        <StyledDetailsTitle>Publisher</StyledDetailsTitle>
                        <StyledMetadata>{publication.publisher || '-'}</StyledMetadata>

                        <StyledDetailsTitle>Publisher Place</StyledDetailsTitle>
                        <StyledMetadata>{publication.publisher_place || '-'}</StyledMetadata>

                        <StyledDetailsTitle>volume/issue/pages</StyledDetailsTitle>
                        <StyledMetadata>{publication.volume}({publication.issue}), {publication.pages}</StyledMetadata>

                    </StyledDetailsContent>
                </StyledMetadata>
            );
        }
        return (<StyledNoDataFound>No data found for publication-ID {publication.id}</StyledNoDataFound>);

    }

}

PublicationListItem.propTypes = {
    publication: PropTypes.object.isRequired,
    hideYears: PropTypes.bool,
    disabled: PropTypes.bool
};

export default PublicationListItem;
